import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, FormsModule, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../../services/api.service';
import {Response} from '../../../dominio/Response';

@Component({
  selector: 'app-form-admin-lenguaje',
  templateUrl: './lenguaje.component.html',
  styleUrls: ['./lenguaje.component.scss']
})
export class LenguajeComponent implements OnInit {
@Input('cod')cod: string;
@Input('id')id: string;
@Input('type')type: string;
@Output('form')formulario = new EventEmitter();
form: FormGroup;
  constructor(private toastr: ToastrService, private apiService: ApiService) { }

  ngOnInit() {
      this.form = new FormGroup({
          cod: new FormControl(this.cod),
          palabras_clave: new FormControl('', Validators.required),
          desarrollo: new FormControl('', Validators.required),
          aparicion_medios: new FormControl(''),
          error: new FormControl(false),
      });
      // actualizo los campos al inicializar y los emito.
      if (this.type === 'modificacion') {
          this.apiService.getDataIdiomas('investigador/informacion_idioma/' + this.id, { lang: this.cod }).subscribe( (resp: Response) => {
              this.form.patchValue({
                      palabras_clave: resp.data.Palabras_clave,
                      desarrollo: resp.data.Desarrollo,
                      aparicion_medios: resp.data.AparicionMedios,
                  }
              );
              this.formulario.emit(this.form.value);
          });
      }
  }

  almacenarFormulario() {
    if (this.form.valid) {
        this.form.value.error = false;
        this.formulario.emit(this.form.value);
    } else {
      this.form.value.error = true;
      this.formulario.emit(this.form.value);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/form/lenguaje/lenguaje.component.ts